import React, { useEffect, useContext, useState } from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import { withTranslationCustom } from 'lib/i18next'
import { wrapEvent } from 'lib/utils/store/wrappers/event/Event'
import { EVENT_REMINDER_OPTIONS, EVENT_TYPE } from 'lib/utils/store/event'

import { Field } from 'formik'
import EventFormModule from 'components/Events/EventForm/EventFormModules/EventFormModule'
import { ExtendedFormikContext } from 'components/Forms/ExtendedFormik'
import { EventFormLogicContext } from 'components/Events/EventForm/EventFormLogic'
import EventReminders from 'components/Events/EventForm/EventFormModules/EventFormReminderModule/EventReminders/EventReminders/EventReminders'
import EventReminderTopic from 'components/Events/EventForm/EventFormModules/EventFormReminderModule/EventReminders/EventReminderTopic/EventReminderTopic'
import CompactFormRow from 'components/Forms/CompactForm/CompactFormRow/CompactFormRow'
import DateTimeInput from 'components/Forms/FormElements/DateTimeInput'
import Icon from 'components/Icon'

import './event-form-remind-next-module.pcss'

const EventFormRemindNextModule = ({ t, module }) => {
    const { trafiData } = useContext(EventFormLogicContext)
    const { setFieldValue, values } = useContext(ExtendedFormikContext)
    const [open, setOpen] = useState(!!values.nextReminderTime)
    const [description, setDescription] = useState(!!values.nextReminderTime)

    const clearFields = () => {
        setFieldValue('nextReminderTime', null)
        setFieldValue('nextRemindBefore', [])
        setFieldValue('nextReminderTopic', '')
    }

    const inspectionValidUntil = trafiData ? trafiData.vehicleDateOfInspectionValidUntil : null

    useEffect(() => {
        if (open) {
            if (values.type === EVENT_TYPE.INSPECTION) {
                let reminderTime = moment(Date.now()).add(1, 'years')
                let description = null

                if (inspectionValidUntil) {
                    if (moment(inspectionValidUntil).isAfter(Date.now())) {
                        reminderTime = inspectionValidUntil
                        description = (
                            <span>
                                {`${t('events:reminders.inspectionValidUntilLabel')} `}
                                <b>{moment(inspectionValidUntil).format('DD.MM.YYYY')}</b>
                            </span>
                        )
                    } else {
                        reminderTime = null
                    }
                }

                setDescription(description)

                // Default the time of next reminder to 12:00am
                reminderTime = reminderTime ? moment(reminderTime).startOf('day').add(12, 'hours') : null

                setFieldValue('nextRemindBefore', [
                    EVENT_REMINDER_OPTIONS[4].value, // 1 week before
                    EVENT_REMINDER_OPTIONS[6].value, // 1 month before
                ])
                setFieldValue('nextReminderTime', reminderTime ? moment(reminderTime).format('YYYY-MM-DD HH:mm') : null)
            } else {
                setFieldValue('nextRemindBefore', [EVENT_REMINDER_OPTIONS[2].value])
                setFieldValue('nextReminderTime', null)
            }

            const nextReminderTopic = values.title
                ? values.title
                : wrapEvent({ type: values.type }).getDefaultTitle(t)

            setFieldValue('nextReminderTopic', nextReminderTopic)

            return () => clearFields()
        } else {
            clearFields()
        }
    }, [open]) // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <EventFormModule className="event-form-remind-next-module" expanded={open}>
            <CompactFormRow
                iconName={module.icon}
                label={t('events:reminders.remindMeAbout')}
                trackName="remindNext"
                onClick={() => setOpen(!open)}
                expandable={true}
                editIcon={open ? (
                    <Icon
                        fa
                        name="trash-alt"
                        cssClass="icon--event-form"
                    />
                ) : null}
            />
            {open && (
                <div>
                    <Field
                        name="nextReminderTime"
                        type="text"
                        label={t('events:reminders.reminderDate')}
                        dateFormat={false}
                    >
                        {(props) => (
                            <DateTimeInput
                                {...props}
                                size="s"
                                disablePastDates
                                disableSetCurrentTime
                                description={description}
                            />
                        )}
                    </Field>
                    <EventReminders fieldName="nextRemindBefore" />
                    <EventReminderTopic
                        fieldName="nextReminderTopic"
                        label={t('events:reminders.title')}
                    />
                </div>
            )}
        </EventFormModule>
    )
}

EventFormRemindNextModule.propTypes = {
    t: PropTypes.func.isRequired,
    module: PropTypes.object.isRequired,
}

export default withTranslationCustom('events')(EventFormRemindNextModule)
